// extracted by mini-css-extract-plugin
export default {"text":"text_M40Nk","overflowHide":"overflowHide_ntpJP"};